import { Component, Input } from "@angular/core";

@Component({
    selector: "app-appointment",
    templateUrl: "./appointment.component.html",
    styleUrls: ["./appointment.component.scss"],
    standalone: false
})
export class AppointmentComponent {
  @Input() booking;

  constructor() {}
}
